import { LOCAL_ANONYMOUS_ID_KEY } from "../../constants";
import { generateNativeUUID } from "../../utils";
import { local } from "../storage";
var generateAnonymousId = function () {
    var storedAnonymousId = local.get(LOCAL_ANONYMOUS_ID_KEY);
    if (storedAnonymousId && typeof storedAnonymousId === "string")
        return storedAnonymousId;
    var newAnonymousId = generateNativeUUID();
    local.set(LOCAL_ANONYMOUS_ID_KEY, newAnonymousId);
    return newAnonymousId;
};
export { generateAnonymousId };
//# sourceMappingURL=utils.js.map